import styled from 'styled-components';

const SubServiceStyle = styled.div`
	.weOfferListItemWrapper {
		--imgSize: 62.2%;
		--imgWrapperWidth: 100%;
		--contentWrapperWidth: 100%;
		--offerItemPaddingTop: var(--sp2-5x);
		--offerItemPaddingBottom: var(--sp2-5x);
		--listItemImageMarginBottom: var(--sp2-5x);
		--titleWrapperMarginBottom: var(--sp2x);
		--descWrapperMarginBottom: var(--sp10x);

		display: block;
		height: 100%;
		padding-top: var(--offerItemPaddingTop);
		padding-bottom: var(--offerItemPaddingBottom);
		border-bottom: 2px solid var(--black);

		.offerContainer {
			.listItemImgWrapper {
				width: var(--imgWrapperWidth);

				.listItemImage {
					height: 100%;
					margin-bottom: var(--listItemImageMarginBottom);

					> div {
						position: unset;
						height: 100%;
						padding-top: var(--imgSize);
					}
				}
			}

			.listItemContentWrapper {
				width: var(--contentWrapperWidth);
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.listItemContentContainer {
					.titleWrapper {
						margin-bottom: var(--titleWrapperMarginBottom);
					}

					.descWrapper {
						margin-bottom: var(--descWrapperMarginBottom);
					}
				}
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		.weOfferListItemWrapper {
			--listItemImageMarginBottom: 0;
			--descWrapperMarginBottom: 0;

			.offerContainer {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				width: 100%;
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		.weOfferListItemWrapper {
			--imgWrapperWidth: 48vw;
			--imgSize: 61.83%;
			--imgWrapperWidth: 44vw;
			--contentWrapperWidth: 41.9vw;
			--offerItemPaddingTop: var(--sp4x);
			--offerItemPaddingBottom: var(--sp4x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) {
		.weOfferListItemWrapper {
			--imgSize: 61.94%;
			--imgWrapperWidth: 44.14vw;
			--contentWrapperWidth: 35.35vw;
			--offerItemPaddingTop: var(--sp4x);
			--offerItemPaddingBottom: var(--sp4x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) {
		.weOfferListItemWrapper {
			--imgSize: 61.96%;
			--imgWrapperWidth: 43.75vw;
			--contentWrapperWidth: 36.71vw;
			--offerItemPaddingTop: var(--sp5x);
			--offerItemPaddingBottom: var(--sp5x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) {
		.weOfferListItemWrapper {
			--imgSize: 62%;
			--imgWrapperWidth: 43.92vw;
			--contentWrapperWidth: 36.89vw;
			--offerItemPaddingTop: var(--sp5x);
			--offerItemPaddingBottom: var(--sp5x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) {
		.weOfferListItemWrapper {
			--imgSize: 62.03%;
			--imgWrapperWidth: 44.44vw;
			--contentWrapperWidth: 37.5vw;
			--offerItemPaddingTop: var(--sp5x);
			--offerItemPaddingBottom: var(--sp5x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) {
		.weOfferListItemWrapper {
			--imgSize: 62.39%;
			--imgWrapperWidth: 42.65vw;
			--contentWrapperWidth: 35.93vw;
			--offerItemPaddingTop: var(--sp8x);
			--offerItemPaddingBottom: var(--sp8x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
		.weOfferListItemWrapper {
			--imgSize: 62.39%;
			--imgWrapperWidth: 38.74vw;
			--contentWrapperWidth: 32.44vw;
			--offerItemPaddingTop: var(--sp9x);
			--offerItemPaddingBottom: var(--sp9x);
			--titleWrapperMarginBottom: var(--sp3x);
		}
	}
`;

export default SubServiceStyle;
